<template>
    <div class="border mb-8">
        <div v-bind:id="'chart-' + id">
            <!--<img v-bind:src="'/sheets/' + id + '/preview'" v-bind:alt="headline"/>-->
        </div>
    </div>
</template>

<script>

    export default {

        props: ['id'],

        data: () => ({
            headline: '',
            href: '/false',
        }),

        mounted() {
            let that = this;

            window.http.get('/sheets/' + this.id + '/json').then((response) => {
                that.json = response.data.json;
                that.href = response.data.href;
                that.headline = response.data.headline;

                that.newChart();
            });
        },

        methods: {
            newChart() {
                this.chart = null;
                this.chart = new Highcharts.Chart(this.json);
            }
        }

    }

</script>
